"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonForm = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const validator_ajv8_1 = __importDefault(require("@rjsf/validator-ajv8"));
const custom_elements_1 = require("./custom-elements");
const core_1 = __importDefault(require("@rjsf/core"));
const utils_1 = require("./utils");
const templates_1 = require("./templates");
const custom_fields_1 = require("./custom-fields");
const utils_2 = require("./custom-elements/custom-select/utils");
const ramda_1 = require("ramda");
const use_filter_for_hiding_presets_props_1 = require("./hooks/use-filter-for-hiding-presets-props");
const widgets = {
    InputWidget: custom_elements_1.CustomInput,
    TextWidget: custom_elements_1.CustomInput,
    SelectWidget: custom_elements_1.CustomSelect,
    CheckboxWidget: custom_elements_1.CustomCheckbox,
    RadioWidget: custom_elements_1.CustomRadio,
    TextareaWidget: custom_elements_1.CustomTextarea,
    ButtonGroupWidget: custom_elements_1.CustomButtonGroup,
    CodeEditorWidget: custom_elements_1.CustomCodeEditor
};
const templates = {
    FieldTemplate: templates_1.FieldTemplate,
    DescriptionFieldTemplate: templates_1.DescriptionFieldTemplate,
    TitleFieldTemplate: templates_1.TitleFieldTemplate,
    FieldErrorTemplate: utils_1.NullComponent,
    ArrayFieldDescriptionTemplate: templates_1.ArrayFieldDescriptionTemplate,
    ArrayFieldItemTemplate: templates_1.ArrayFieldItemTemplate,
    ButtonTemplates: {
        AddButton: templates_1.AddButton,
        MoveDownButton: templates_1.MoveDownButton,
        RemoveButton: templates_1.RemoveButton,
        MoveUpButton: templates_1.MoveUpButton
    }
};
exports.JsonForm = (0, react_1.memo)(({ id = 'json-form', tagName, schema: initSchema, widgets: extendWidgets, fields: extendFields, templates: extendTemplates, formData: formDataProp, onSubmit, onChangeValidStatus, onChange, externalSelectsOptions = {}, addHttpClientPath = [], formContext, customValidate, httpClient, propsForSettingsAreHidden }) => {
    // todo: move propsForSettingsAreHidden to the context
    const fields = (0, react_1.useMemo)(() => {
        return {
            'widget-instance': (props) => (0, custom_fields_1.WidgetInstanceField)(Object.assign(Object.assign({}, props), { propsForSettingsAreHidden })),
            instance: (props) => (0, custom_fields_1.WidgetInstanceField)(Object.assign(Object.assign({}, props), { propsForSettingsAreHidden })),
            'chart-settings': (props) => (0, custom_fields_1.ChartSettingsField)(Object.assign({}, props))
        };
    }, [propsForSettingsAreHidden]);
    const ref = (0, react_1.useRef)(null);
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.validateForm())
            setIsValid(true);
    }, [setIsValid]);
    const schema = (0, react_1.useMemo)(() => {
        const updatedSchema = global.structuredClone(initSchema);
        Object.entries(externalSelectsOptions).forEach(([key, options]) => {
            //This code phrase is necessary to prevent resetting of already
            //selected parameters while the options are not loaded yet.
            //Because at form initialization validation is triggered and it resets the value of forms,
            // as you know @rjsf works only synchronously.
            const initOptions = formDataProp === null || formDataProp === void 0 ? void 0 : formDataProp[key];
            if ((0, ramda_1.isEmpty)(options) && !(0, ramda_1.isEmpty)(initOptions)) {
                const options = Array.isArray(initOptions)
                    ? initOptions.map((value) => ({ value, title: value }))
                    : [{ value: initOptions, title: '' }];
                (0, utils_2.addOptionsToSelect)(updatedSchema, key, options);
                return;
            }
            (0, utils_2.addOptionsToSelect)(updatedSchema, key, options);
        });
        addHttpClientPath.forEach((item) => {
            (0, utils_1.addHttpClientToSchema)(updatedSchema, item, httpClient);
        });
        return updatedSchema;
    }, [externalSelectsOptions, initSchema]);
    const finalSchema = (0, use_filter_for_hiding_presets_props_1.useFilterForHidingPresetsProps)(schema, !!(formDataProp === null || formDataProp === void 0 ? void 0 : formDataProp.isPreset), propsForSettingsAreHidden);
    (0, react_1.useEffect)(() => {
        if (onChangeValidStatus)
            onChangeValidStatus(isValid);
    }, [isValid, onChangeValidStatus]);
    const [formData, setFormData] = (0, react_1.useState)(formDataProp);
    (0, react_1.useEffect)(() => {
        setFormData(formDataProp);
    }, [formDataProp]);
    return (react_1.default.createElement(styled_1.FormWrapper, null,
        react_1.default.createElement(core_1.default, { ref: ref, liveValidate: true, id: id, tagName: tagName, onSubmit: (submitEvent) => {
                onSubmit(submitEvent.formData);
            }, onChange: (changeEvent) => {
                setIsValid(!changeEvent.errors.length);
                setFormData(changeEvent.formData);
                if (onChange)
                    onChange(changeEvent.formData);
            }, 
            //@ts-ignore
            httpClient: httpClient, schema: finalSchema.jsonSchema, uiSchema: finalSchema.uiSchema, extraErrors: finalSchema.extraErrors, showErrorList: false, validator: validator_ajv8_1.default, widgets: Object.assign(Object.assign({}, widgets), extendWidgets), noHtml5Validate: true, formData: formData, templates: Object.assign(Object.assign({}, templates), extendTemplates), fields: Object.assign(Object.assign({}, fields), extendFields), formContext: formContext, customValidate: customValidate },
            react_1.default.createElement(react_1.default.Fragment, null))));
});
//# sourceMappingURL=json-form.js.map